import React, {Component} from 'react';

export default class Link extends Component {
  constructor(props) {
    super(props);
  }

  render()
  {
    var st={
      blue:{
        borderRadius:"20px",
            backgroundColor:" #1a84eb",
            borderBottomRightRadius:0,
            borderBottomLeftRadius:0,
            height:"11.1px",

      },
      img:{
        top:0,
        padding:0,
      },

      box:{

        borderRadius: "7px",
        borderTopRightRadius:0,
        borderTopLeftRadius:0,
        backgroundColor:"#ffffff",
        height:"170px",
        boxShadow: "0 3px 5px 0 rgba(0, 0, 0, 0.3)"
      },
    }

    return(
        <div>
          <div className="img-rounded" style={st.blue}></div>
            <div className="panel panel-default" style={st.box}>
              <div className="panel-body">
                    <h3><strong>LINKS</strong></h3>
                <div >
                <strong>Survey : </strong>{this.props.data.survey}
                </div>
                <br />
                <div >
                  <strong>Report : </strong>{this.props.data.report}
                </div>
              </div>
          </div>
        </div>
      );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/clientDashboard/Link.js
 **/